import { useState, useEffect } from 'react'
import { supabase } from './supabase'
import Auth from './components/Auth'
import Onboarding from './components/Onboarding'
import Dashboard from './components/Dashboard'
import './App.css'

export default function App() {
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) loadProfile(session.user.id)
      else setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) loadProfile(session.user.id)
      else { setProfile(null); setLoading(false) }
    })
    return () => subscription.unsubscribe()
  }, [])

  async function loadProfile(userId) {
    setLoading(true)
    const { data } = await supabase.from('profiles').select('*').eq('id', userId).single()
    setProfile(data)
    setLoading(false)
  }

  async function handleSignOut() {
    try {
      Object.keys(localStorage).forEach(key => {
        if (session && key.includes(session.user.id)) localStorage.removeItem(key)
      })
    } catch {}
    await supabase.auth.signOut()
  }

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#fff' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: '1.5rem', color: '#00712D', marginBottom: '0.5rem' }}>The Application Multiplier</div>
        <div style={{ color: '#888', fontSize: '0.9rem' }}>Loading your search...</div>
      </div>
    </div>
  )

  if (!session) return <Auth />
  if (!profile?.onboarding_complete) return <Onboarding session={session} onComplete={() => loadProfile(session.user.id)} />
  return <Dashboard session={session} profile={profile} onSignOut={handleSignOut} onProfileUpdate={() => loadProfile(session.user.id)} />
}
